module.exports = __webpack_public_path__ + "static/img/PALERMO_PAINT.b5cf921.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/materials/Frendel/PALERMO_PAINT.jpg
// module id = ij5H
// module chunks = 0